import { Box, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import Datepicker from '../../../common/datePicker'
import { focusElemnt, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { SplitButton } from '../../../common/SplitButton'
import UserWiseBalanceTable from './UserWiseBalanceTable'
import { getUserWiseBalanceReportData, userwiseColumnDefs, userwiseDummyData } from './constants'
import moment from 'moment'
import useToken from '../../../helpers/useTokens'
import { useSearchParams } from 'react-router-dom'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { downloadPDF } from '../../Reports/analysisReport/pdfAutotable'
import { PostRequestCachedV3 } from '../../../common/api'
import { urls } from '../../../common/constants'
import { CleanHands } from '@mui/icons-material'
import { getDecryptedReportParams } from '../../../common/loginDecode'

const UserWiseBalance = (props) => {
  // const { isFromUrl } = props
  const [filters, setFilters] = useState({ fromDate: moment(new Date()), toDate: moment(new Date()), branch: '', user: '' })
  const [branchList, setBranchList] = useState([])
   const [userList, setUserList] = useState([{originalUsers:[], filteredUsers:[]}])
  const setAlert = useSetAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  const reportName = 'Userwise Balance Summary'
  const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)
  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intBranchCityID = +searchParams.get('CT') || 0
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.intUserID = +searchParams.get('U') || 0
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strCityName = searchParams.get('CTN') || 0
    loginData.strBranchName = searchParams.get('BN') || ''
    loginData.strUserName = searchParams.get('UN') || ''
    isFromUrl = true
  }
  const criteriaHeaders = [
    { field: 'fromDate', header: 'From Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Date', textAlign: 'left' },
    { field: 'branch', header: 'Select Branch', textAlign: 'left' },
    { field: 'user', header: 'Select User', textAlign: 'left' },
  ]
  const criteriaData = {
    fromDate: moment(filters?.fromDate).format('DD-MM-YYYY'),
    toDate: moment(filters?.toDate).format('DD-MM-YYYY'),
    branch: filters?.branch?.BranchName,
    user: filters?.user?.UserName,
    dataType: 'entry',
  }
  useEffect(() => {
    if (loginData?.intCompanyID) {
      const branchBody = {
        intUserID: 0,
        intCompanyID: loginData?.intCompanyID,
        intBranchID: 0,
        strBranchName: '',
        strBranchCode: '',
        intStateID: 0,
        intCityID: 0,
        intIsActive: 1,
      }
      setLoader(true)
      PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, branchBody, true, 24 * 60 * 60 * 1000)
        .then((res) => {
          setLoader(false)
          if (res.status === 'Success') {
            let branchData = removeDuplicatesFromArray(res?.Data?.Table, 'BranchID')
            const branchNames = branchData.map(item => ({ BranchID: item.BranchID, BranchName: item.BranchName, CityID:item.CityID }));
            setBranchList(branchNames);
            const loginBranch = branchNames?.filter((val) => val.BranchID === loginData?.intBranchID)
            setFilters((prev) => ({ ...prev, branch: loginBranch?.[0] }))
          }
        })

      let userBody = {
        intUserID: 0,
        intCompanyID: loginData?.intCompanyID,
        intBranchID: 0,
        strUserName: "",
        strLoginID: "",
        strPassword: "",
        strContactNo: "",
        intRoleID: 0,
        intIsActive: 1
      }
      setLoader(true)
      PostRequestCachedV3(urls.getUserList, userBody, true, 24 * 60 * 60 * 1000)
        .then((res) => {
          setLoader(false)
          if (res.status === 'Success') {
            let userData = removeDuplicatesFromArray(res?.Data?.Table, 'UserID')
            const userNames = userData.map(item => ({UserID:item.UserID,UserName:item.UserName, BranchID: item.BranchID }));
            setUserList({originalUsers:userNames, filteredUsers:userNames});
            const loginUser = userNames?.filter((val) => val.UserID === loginData?.intUserID)
            setFilters((prev) => ({ ...prev, user: loginUser?.[0] }))
          } 
        })
       
    }

  }, [loginData?.intCompanyID])
   useEffect(() => {
      if (userList?.originalUsers?.length > 0) {
        let newData = userList?.originalUsers?.filter((val) => val.BranchID === filters?.branch?.BranchID)
        const userNames = newData.map(item => ({UserID:item.UserID, UserName:item.UserName, BranchID: item.BranchID }));
        setUserList((prev) => ({ ...prev, filteredUsers: userNames }))
        const loginUser = userNames?.filter((val) => val.UserID === loginData?.intUserID)
        setFilters((prev) => ({ ...prev, user:loginUser?.length>0 ? loginUser?.[0] : userNames?.[0] }))
      }
    }, [filters?.branch])
     const handleClick1 = async (isPdf = false) => {
        try {
          const body = {
            CompanyID: loginData?.intCompanyID,
            CityID: filters?.branch?.CityID,
            BranchID: filters?.branch?.BranchID,
            UserID: filters?.user?.UserID,
            FromDate: moment(new Date(filters?.fromDate)).format('YYYY-MM-DD'),
            ToDate: moment(new Date(filters?.toDate)).format('YYYY-MM-DD')
          }
    
          setLoader(true)
    
          const reportData = await getUserWiseBalanceReportData(body, setAlert)
    
          setLoader(false)
    
          if (reportData.length === 0) {
            setAlert({ show: true, msg: 'No Data Found', nextId: '' })
            return
          }
    
          const headers = userwiseColumnDefs?.map((val) => ({
            ...val,
            field: val.dataKey,
            align: val.align || (val.xlCol?.dataType === 'quantity' ? 'right' : 'left'),
            exportHead: val.header,
            weight: val.weight ?? 40,
            dataType: 'header'
          }))
    
          if (isPdf) {
            downloadPDF({
              reportName,
              criteriaHeaders,
              criteriaData: [criteriaData],
              tableData: reportData,
              visibleColumns: headers,
              loginData,
              hideHeader: false
            })
            return
          }
    
          const rid = Date.now().toString()
          window.generatedReports = window.generatedReports || {}
          window.generatedReports[rid] = {
            id: 'user_wise_balance_report',
            reportName,
            reportData,
            criteriaHeaders,
            criteriaData,
            saveMeta: {
              CompanyID: loginData?.intCompanyID,
              CityID: filters?.branch?.CityID || 0,
              BranchID: filters?.branch?.BranchID || 0,
              UserID:filters?.user?.UserID || 0,
              FromDate: moment(new Date(filters?.fromDate)).format('YYYY-MM-DD') || '',
              ToDate: moment(new Date(filters?.toDate)).format('YYYY-MM-DD') || ''
            },
            loginData,
          }
    
          window.open(`/view-reportV2?rid=${rid}`, "_blank")
    
        } catch (err) {
          setLoader(false)
          setAlert({ show: true, msg: err.message, nextId: '' })
        }
      }

  return (
    <>
      <Box sx={sx.reportFlex}>
         {isFromUrl ? <></> : <>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id={'selectCompnay'}
            label={'Select Company'}
            // defaultvalue={loginData.strCompanyName}
            disabled={true}
            // onSelect={(val) => { setSelCompany(val); setShowTable(false) }}
            width="300px"
          />{' '}
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button
            variant="contained"
            disabled={true}
            style={{ ...sx.fullHeight, ...sx.novp }}
            id={'goButton'}
            className="btn btn-primary"
          >
            GO
          </Button>
        </Item></>}
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            name={'from_collection_date'}
            value={filters?.fromDate}
            label={'From Date'}
            id={'fromDate'}
            dateChange={(date) => {
              setFilters((prev) => ({
                ...prev,
                fromDate: date
              }))
              focusElemnt('toDate')
            }}
            width="100%"
          />
        </Item>
        <Item sx={isFromUrl ? { ...sx.itemsxGrow, width: '60%' } : sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={'To Date'}
            value={filters?.toDate}
            id={'toDate'}
            dateChange={(date) => {
              setFilters((prev) => ({
                ...prev,
                toDate: date
              }))
              focusElemnt('destCity')
            }}
            width="100%"
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label="Select Branch"
            id="selectBranch"
            nextId={''}
            prevId={''}
            data={branchList||[]}
            defaultvalue={filters?.branch?.BranchName || ""}
            dataKey={`BranchName`}
            idKey={`BranchID`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                branch: val
              }))
            }}
            disabled={false}
            isObjArr={true}
            searchPlaceholder={`Search By Branch Name`}
            width="100%"
            listWidth={'250px'}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label="Select User"
            id="selectCity"
            nextId={''}
            prevId={''}
            defaultvalue={filters?.user?.UserName || ''}
            data={userList?.filteredUsers||[]}
            dataKey={`UserName`}
            idKey={`UserID`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                user: val
              }))
            }}
            disabled={false}
            isObjArr={true}
            searchPlaceholder={`Search By User Name`}
            width="100%"
          />
        </Item>
        {isFromUrl ?
          <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} >
            DOWNLOAD PDF
          </Button> : <>
            <Item
              sx={sx.itemsx}
              onKeyDown={(e) => navigation3(e, 'refreshBtn', 'status', () => handleClick1(false))}
            >
              <SplitButton
                hideToggle={true}
                options={['GENERATE']}
                id1={'splitButton'}
                onClick1={() => handleClick1(false)}
              />
            </Item>
          </>}
      </Box>
    </>
  )
}

export default UserWiseBalance
